import { CourseIntro } from '../models/course-intro.model';

export const JrFrontCourses: { [key: string]: any } = {
    basis: {
      title: 'Βάζοντας τα σωστά θεμέλια',
      content:
      'Οι βάσεις που θα στήσουμε σε αυτό τον κύκλο είναι αυτές που θα σε ακολουθήσουν στο υπόλοιπο της καριέρας σου. Στόχος του κύκλου αποτελεί η εισαγωγή στον προγραμματισμό και η εις βάθος κατανόηση των τεχνολογιών που αποτελούν τον θεμέλιο λίθο κάθε web εφαρμογής. Είτε είσαι τελείως καινούργιος, είτε θέλεις να φρεσκάρεις τις γνώσεις σου, αυτός ο κύκλος μαθημάτων θα σε καλύψει.',
      duration: 102,
      lessons: ['Visual Studio Code', 'HTML', 'CSS', 'JavaScript', 'Dev Tools'],
      pngImages: [
        'assets/images/topics/vscode_logo.png',
        'assets/images/topics/html_logo.png',
        'assets/images/topics/css_logo.png',
        'assets/images/topics/js_logo.png',
        'assets/images/topics/googledevelopers_logo.png',
      ],
      webpImages: [
        'assets/images/topics/vscode_logo.webp',
        'assets/images/topics/html_logo.webp',
        'assets/images/topics/css_logo.webp',
        'assets/images/topics/js_logo.webp',
        'assets/images/topics/googledevelopers_logo.webp',
      ],
      path: 'basis'
    },
    development: {
      title: 'Μάθε το Development Environment',
      content:
        'Σε αυτό τον κύκλο θα κατανοήσεις τι χρειάζεται για την ανάπτυξη μιας web εφαρμογής. Οι γλώσσες προγραμματισμού είναι απλώς τα εργαλεία που χρησιμοποιούμε για να το πετύχουμε αυτό. Θα αποκτήσεις την αντίληψη και την λογική, θα κατανοήσεις το περιβάλλον development και θα εισαχθείς στις τεχνολογίες που θα χρειαστείς για αυτό.',
      duration: 35,
      lessons: ['Git', 'GitHub', 'npm', 'Webpack', 'NodeJS', 'UX/UI', 'TypeScript', 'SASS', 'Mark Down', 'Postman','ESlint', 'Prettier', 'Gulp', 'Figma'],
      pngImages: [
        'assets/images/topics/git_logo.png',
        'assets/images/topics/github_logo.png',
        'assets/images/topics/npm_logo.png',
        'assets/images/topics/webpack_logo.png',
        'assets/images/topics/nodejs_logo.png',
        'assets/images/topics/ux_ui.png',
        'assets/images/topics/typescript_logo.png',
        'assets/images/topics/sass_logo.png',
        'assets/images/topics/markdown_logo.png',
        'assets/images/topics/postman_logo.png',
        'assets/images/topics/eslint_logo.png',
        'assets/images/topics/prettier_logo.png',
        'assets/images/topics/gulp_logo.png',
        'assets/images/topics/figma_logo.png',
      ],
      webpImages: [
        'assets/images/topics/git_logo.webp',
        'assets/images/topics/github_logo.webp',
        'assets/images/topics/npm_logo.webp',
        'assets/images/topics/webpack_logo.webp',
        'assets/images/topics/nodejs_logo.webp',
        'assets/images/topics/ux_ui.webp',
        'assets/images/topics/typescript_logo.webp',
        'assets/images/topics/sass_logo.webp',
        'assets/images/topics/markdown_logo.webp',
        'assets/images/topics/postman_logo.webp',
        'assets/images/topics/eslint_logo.webp',
        'assets/images/topics/prettier_logo.webp',
        'assets/images/topics/gulp_logo.webp',
        'assets/images/topics/figma_logo.webp',
      ],
      path: 'development'
    },
    framework: {
      title: 'Ανάλαβε το framework σου',
      content:
        'Σε αυτό τον κύκλο θα εκπαιδευτείς σε ένα από τα δύο πιο δημοφιλή και διαδεδομένα JavaScript frameworks: React ή Angular , πάνω στα οποία αναπτύσσονται όλα τα μεγάλα project. Μαζί με αυτό θα γνωρίσεις και το application state είτε με τη μορφή της Redux ή του NgRx στο οποίο γίνεται η κεντρική διαχείριση δεδομένων του frontend. Στον κύκλο αυτό θα χρησιμοποιήσεις όλες τις πολύτιμες γνώσεις και βάσεις που απέκτησες στη διάρκεια της σπουδής σου και θα προετοιμαστείς για την αγορά εργασίας.',
      duration: 46,
      lessons: ['Angular', 'React', 'Redux', 'NgRx'],
      pngImages: [
        'assets/images/topics/angular_logo.png',
        'assets/images/topics/react_logo.png',
        'assets/images/topics/redux_logo.png',
        'assets/images/topics/ngrx_logo.png',
      ],
      webpImages: [
        'assets/images/topics/angular_logo.webp',
        'assets/images/topics/react_logo.webp',
        'assets/images/topics/redux_logo.webp',
        'assets/images/topics/ngrx_logo.webp',
      ],
      path: 'framework'
    },
    
}



export const AngularFrameworkCourses: { [key: string]: CourseIntro } = {
  basis: {
    title: 'Μαθαίνοντας τα βασικά στοιχεία της Angular',
    content:
      'Σε αυτή την ενότητα θα μάθεις όλα τα βασικά στοιχεία της Angular, τα οποία θα σε βοηθήσουν να κατανοήσεις σε βάθος πώς λειτουργεί το Angular Framework. Θα μάθεις να δημιουργείς εφαρμογές Angular από το μηδέν χρησιμοποιώντας το Angular CLI. Θα εξερευνήσεις σε βάθος τις βασικές έννοιες όπως modules, components, directives και pipes. Επίσης, θα κατανοήσεις τι είναι το Angular DI (Dependency Injection) και γιατί είναι τόσο σημαντικό. Τέλος, θα ενισχύσεις τις γνώσεις σου στην Typescript μαθαίνοντας τα βασικά και τα πιο συχνά χρησιμοποιούμενα χαρακτηριστικά της.',
    duration: 30,
    lessons: [
      'Angular CLI',
      'Components',
      'Directives',
      'Pipes',
      'Angular DI',
      'Component Lifecycle Hooks',
      'Change Detection Mechanism',
      'Typescript',
    ],
    pngImages: [
      'assets/images/topics/vscode_logo.png',
      'assets/images/topics/angular_logo.png',
      'assets/images/topics/typescript_logo.png',
    ],
  },
  development: {
    title: 'Προχωρώντας ένα βήμα παραπέρα',
    content:
      'Σε αυτές την ενότητα θα μάθεις το Angular Routing και πώς λειτουργεί. Θα εξικοιωθείς με τις φόρμες (forms) στην Angular. Οι φόρμες έχουν αρκετές δυσκολίες. Με την βοήθεια της Angular θα μάθεις πως να επικυρώνεις, υποβάλεις και εμφανίζεις τα διάφορα στοιχεία μας φόρμας. Επιπλέον, θα μάθεις τι είναι τα Angular services και πώς μπορείς να τις χρησιμοποιήσεις προκειμένου να μοιραστείς δεδομένα ή κατάσταση μεταξύ των components. Τέλος, θα πάρεις μια καλή γεύση από το /unit testing και θα μάθεις πώς να γράφεις πιο ελέγξιμο κώδικα.',
    duration: 15,
    lessons: [
      'Angular Services',
      'Angular Routes',
      'Reactive Forms',
      'RxJs',
      'Karma',
      'Jest',
    ],
    pngImages: [
      'assets/images/topics/router_logo.png',
      'assets/images/topics/forms_logo.png',
      'assets/images/topics/rxjs_logo.png',
      'assets/images/topics/karma_logo.png',
      'assets/images/topics/jest_logo.png',
    ],
  },
  framework: {
    title: 'Reactive services και NGRX',
    content:
      'Σε αυτή την ενότητα θα μάθεις τι είναι η διαχείριση κατάστασης (state management) και γιατί είναι τόσο σημαντική για μεγάλες και επεκτάσιμες εφαρμογές. Θα μάθεις πώς μπορείς να αξιοποιήσεις τις υπηρεσίες της Angular και την RX js προκειμένου να αναπτύξεις διαδραστικές υπηρεσίες (reactive services) που διαχειρίζονται την κατάσταση της εφαρμογής. Επίσης θα εξερευνήσεις το NGRX το οποίο είναι το πιο διάσημο framework για την κατασκευή διαδραστικών εφαρμογών στην Angular.',
    duration: 15,
    lessons: ['NgRx'],
    pngImages: ['assets/images/topics/ngrx_logo.png'],
    webpImages: ['assets/images/topics/ngrx_logo.webp'],
  },
};
export const AICourses: { [key: string]: CourseIntro } = {
  basis: {
    title: 'Βάζοντας τα σωστά θεμέλια',
    content:
    'Οι βάσεις που θα στήσουμε σε αυτό τον κύκλο είναι αυτές που θα σε ακολουθήσουν στο υπόλοιπο της καριέρας σου.',
    duration: 15,
    lessons: ['Introduction to AI', '..', '..', '..', '..', '..'],
    pngImages: [
      'assets/images/topics/angular_logo.png', 'assets/images/topics/testing_2.png', 'assets/images/topics/agile.png', 'assets/images/topics/typescript_logo.png', 'assets/images/topics/java.png', 'assets/images/topics/python.png', 'assets/images/topics/git_logo.png','assets/images/topics/rest_api.png', 'assets/images/topics/postman_logo.png','assets/images/topics/cypress.png','assets/images/topics/selenium.png', 'assets/images/topics/rest_assured.png'
    ],
  },
}

export const JrTestAutomationEngineerCourses: { [key: string]: CourseIntro } = {
  basis: {
    title: 'Βάζοντας τα σωστά θεμέλια',
    content:
    'Οι βάσεις που θα στήσουμε σε αυτό τον κύκλο είναι αυτές που θα σε ακολουθήσουν στο υπόλοιπο της καριέρας σου.',
    duration: 64,
    lessons: ['Introduction to Test Automation', 'Test Automation 101', 'Test Automation in Agile', 'Programming Basics', 'API Test Automation', 'Web Test Automation'],
    pngImages: [
      'assets/images/topics/testing.png', 'assets/images/topics/testing_2.png', 'assets/images/topics/agile.png', 'assets/images/topics/typescript_logo.png', 'assets/images/topics/java.png', 'assets/images/topics/python.png', 'assets/images/topics/git_logo.png','assets/images/topics/rest_api.png', 'assets/images/topics/postman_logo.png','assets/images/topics/cypress.png','assets/images/topics/selenium.png', 'assets/images/topics/rest_assured.png'
    ],
  },
}



export const JrQAEngineerCourses: { [key: string]: CourseIntro } = {
  basis: {
    title: 'Βάζοντας τα σωστά θεμέλια',
    content:
    'Οι βάσεις που θα στήσουμε σε αυτό τον κύκλο είναι αυτές που θα σε ακολουθήσουν στο υπόλοιπο της καριέρας σου.',
    duration: 32,
    lessons: ['Introduction to QA', 'Testing in Software Engineering', 'Testing 101', 'Software Testing Tools'],
    pngImages: [
      'assets/images/topics/qa.png', 'assets/images/topics/testing_3.png','assets/images/topics/jira.png', 'assets/images/topics/confluence.png'
    ],
  }
}